var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","d-flex":""}},[_vm._t("content",null,{"hover":_vm.hover}),_vm._t("actions",null,{"hover":_vm.hover})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }